// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"3c9d1aee","89":"b8209e7a","372":"37fa65e1","718":"8c62b985"}[chunkId] + ".chunk.js";
};